import { render, staticRenderFns } from "./AlertName.vue?vue&type=template&id=3da2b034&scoped=true&"
import script from "./AlertName.vue?vue&type=script&lang=js&"
export * from "./AlertName.vue?vue&type=script&lang=js&"
import style0 from "./AlertName.vue?vue&type=style&index=0&id=3da2b034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2b034",
  null
  
)

export default component.exports